export const ENVIRONMENT = process.env.NODE_ENV;

export const API_URL =
  ENVIRONMENT === 'production' ? 'https://theenrichmentlist.markwilkinsapps.com/api' : 'http://localhost:5000/api';

export const RELEASE_STRING = `${process.env.REACT_APP_RELEASE || ENVIRONMENT}`;

export enum ASSESSMENT_HOURS_TO_TYPE {
  full = 48,
  initial = 24,
  complete = 0,
}
